var exports = {
  "pN": "Nameplates.module__plate___aS1aVD",
  "Sl": "Nameplates.module__image___aS1aVD" + " " + "Nameplates.module__plate___aS1aVD",
  "ZO": "Nameplates.module__aurora___aS1aVD",
  "Bh": "Nameplates.module__sunset___aS1aVD",
  "zx": "Nameplates.module__ocean___aS1aVD",
  "hc": "Nameplates.module__galaxy___aS1aVD",
  "sL": "Nameplates.module__sakura___aS1aVD",
  "_0": "Nameplates.module__circuit___aS1aVD",
  "SO": "Nameplates.module__ember___aS1aVD",
  "Xx": "Nameplates.module__mint___aS1aVD",
  "yp": "Nameplates.module__plateDrift___aS1aVD",
  "CS": "Nameplates.module__animated___aS1aVD",
};

module.exports = exports;
